module.exports = __webpack_public_path__ + "img/gateway.daa467d6.svg";